import { cloneDeep } from '@/global/utils/utils'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'
import { FormDataBuilder } from '@/global/services/helpers/formDataBuilder'
import { showDetailsAction, deleteAction, activationAction } from '@/global/components/table/helpers/tableActions'

const TABLE_COMPONENT_KEY = 'tracker-firmware-versions'
export default {
  data () {
    return {
      manageFirmwareVersionDialogConfig: {
        openDialog: false,
        positiveButtonText: this.$t('base.save'),
        negativeButtonText: this.$t('base.cancel'),
        title: '',
        callback: () => this.onSaveFirmwareVersion()
      },
      informationDialogConfig: {
        openDialog: false,
        message: '',
        title: '',
        positiveBtnText: '',
        negativeBtnText: this.$t('base.cancel'),
        callbackFn: () => {}
      },
      firmwareVersionFormData: {},
      firmwareVersionFormValidationErrors: {},
      showSaveFirmwareVersionLoader: false,
      mainTableKey: TABLE_COMPONENT_KEY
    }
  },

  computed: {
    tableRowActions () {
      return [
        {
          ...showDetailsAction(this.$t, (event) => this.showEdit(event)),
          visible: !!this.permissions?.canUpdate
        },
        {
          ...activationAction(this.$t, (event) => this.onFirmwareVersionActivation(event), (event) => !event?.data?.deactivated_at),
          visible: (event) => !!this.permissions?.canActivate
        },
        {
          ...deleteAction(this.$t, (event) => this.onFirmwareVersionDelete(event)),
          visible: this.permissions?.canDelete
        }
      ]
    }
  },

  methods: {
    showEdit (event) {
      const { data } = event || {}
      const { name } = data?.firmware || {}
      // cloneDeep for disabling changes on source object by reference
      const clonedData = cloneDeep(data)
      // edit data
      const editData = {}

      // map edit data
      editData.firmware_id = clonedData?.firmware?.id
      editData.version = clonedData?.version
      editData.path = clonedData?.path
      editData.id = clonedData?.id

      // set form data
      this.firmwareVersionFormData = editData

      this.$set(this.manageFirmwareVersionDialogConfig, 'title', this.$t('base.tracker_firmware_versions') + (name ? ' - ' + name : ''))
      this.$set(this.manageFirmwareVersionDialogConfig, 'edit', true)
      this.$set(this.manageFirmwareVersionDialogConfig, 'openDialog', true)
    },

    onFirmwareVersionActivation (event) {
      const {
        deactivated_at: deactivatedAt,
        id,
        firmware
      } = event?.data || {}

      if (!id) {
        return
      }

      const title = !deactivatedAt ? this.$t('base/tracker_firmware_version.deactivate') : this.$t('base/tracker_firmware_version.activate')
      this.$set(this.informationDialogConfig, 'title', title + (firmware?.name ? ' - ' + firmware.name : ''))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('base/tracker_firmware_version.confirm_deactivation') : this.$t('base/tracker_firmware_version.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.handleFirmwareVersionActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async handleFirmwareVersionActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.mainTableKey] || {}
        await api('base').patch(`tracker-firmware-version/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onFirmwareVersionDelete (event) {
      const {
        id,
        firmware
      } = event?.data || {}

      if (!id) {
        return
      }

      const title = this.$t('base/tracker_firmware_version.delete')
      this.$set(this.informationDialogConfig, 'title', title + (firmware?.name ? ' - ' + firmware.name : ''))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('base/tracker_firmware_version.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.handleFirmwareVersionDeletion(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async handleFirmwareVersionDeletion (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.mainTableKey] || {}

        await api('base').delete(`tracker-firmware-version/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async onSaveFirmwareVersion () {
      try {
        this.showSaveFirmwareVersionLoader = true
        if (!this.firmwareVersionFormData?.id) {
          return
        }

        const formDataBuilder = new FormDataBuilder()
        const formData = formDataBuilder.build(this.firmwareVersionFormData)
        formData.append('_method', 'PATCH')

        await api('base').post(`tracker-firmware-version/${this.firmwareVersionFormData.id}`, formData)

        const { fetchData } = registeredTableHandlers[TABLE_COMPONENT_KEY] || {}
        this.closeManageFirmwareVersionDialog()
        // refresh table after success import
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        this.firmwareVersionFormValidationErrors = exception?.response?.data?.errors || {}
        console.error(exception)
      }
      finally {
        this.showSaveFirmwareVersionLoader = false
      }
    },

    closeManageFirmwareVersionDialog () {
      this.$set(this.manageFirmwareVersionDialogConfig, 'openDialog', false)
      this.firmwareVersionFormData = {}
      this.firmwareVersionFormValidationErrors = {}
    },

    onClearFirmwareVersionValidationErrors (key) {
      if (this.simCardFormValidationErrors?.[key]) {
        this.$delete(this.simCardFormValidationErrors, key)
      }
    }
  }
}
